"use strict";

/*
  Component for generating `UIAvatarTags`
  Example: `AssociationSelect`

  You get:
   - A list of UIAvatarTags

  You need to provide:
   - values {Iterable} - an iterable of values you want as tags

  Optional Props:
    valuesAreObjectTypes: {bool} whether the values are a contact, company, or deal
                          which will (optionally) generate links for you
    inlineTags: {bool} block vs inline
    closeableTag: {bool} displays x for all tags (see note below on individual tags)
    handleRemove: {func} callback for closeableTag
    tagLinks: {bool} include links as tag text
    tagLinkTarget: {string} eg "_blank"

  Individual tags may be optionally closeable/not closeable by passing a value
  that is an object with the following shape:
    {
      value: value // your standard tag information
      tagOptions: {readOnly: true}
    }

*/
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _underscore = require("underscore");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _reactImmutableRenderMixin = _interopRequireDefault(require("react-immutable-render-mixin"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UIAvatarTag = _interopRequireDefault(require("ui-addon-avatars/UIAvatarTag"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _SubjectPermissions = require("crm_ui/utils/SubjectPermissions");

var _loggers = require("customer-data-tracking/loggers");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var getSeleniumProps = function getSeleniumProps(props) {
  return Object.keys(props).reduce(function (accum, prop) {
    if (prop.includes('selenium')) {
      accum[prop] = props[prop];
    }

    return accum;
  }, {});
};

var AvatarTagList = (0, _createReactClass.default)({
  displayName: 'AvatarTagList',
  propTypes: {
    closeableTag: _propTypes.default.bool,
    handleRemove: _propTypes.default.func,
    inlineTags: _propTypes.default.bool,
    onClick: _propTypes.default.func,
    tagLinks: _propTypes.default.bool,
    tagLinkTarget: _propTypes.default.string,
    values: _reactImmutableProptypes.default.list,
    valuesAreObjectTypes: _propTypes.default.bool,
    // temporary for tracking
    trackingLocation: _propTypes.default.string,
    objectType: _propTypes.default.string,
    className: _propTypes.default.string
  },
  mixins: [_ComponentWithPartials.default, _reactImmutableRenderMixin.default],
  getDefaultProps: function getDefaultProps() {
    return {
      inlineTags: true,
      closeableTag: true,
      tagLinks: true,
      onClick: function onClick() {}
    };
  },
  handleTrackClick: function handleTrackClick() {
    var _this$props = this.props,
        trackingLocation = _this$props.trackingLocation,
        objectType = _this$props.objectType;

    if (!trackingLocation || !objectType) {
      return null;
    }

    return _loggers.CrmLogger.logRecordInteraction(objectType, {
      action: 'Clicked association tag link'
    });
  },
  makeTag: function makeTag(value) {
    var domain;
    var email;
    var link;
    var objectId;
    var objectType;
    var options;
    var valueString;
    var vid;
    var companyId;
    var closeableTag = this.props.closeableTag;
    var _this$props2 = this.props,
        handleRemove = _this$props2.handleRemove,
        tagLinkTarget = _this$props2.tagLinkTarget,
        tagLinks = _this$props2.tagLinks,
        valuesAreObjectTypes = _this$props2.valuesAreObjectTypes,
        onClick = _this$props2.onClick;

    if (!value) {
      return null;
    }

    if (value.tagOptions) {
      options = value.tagOptions;
      value = value.value;
    }

    if (options && options.textOnly) {
      valueString = value;
    } else if (valuesAreObjectTypes) {
      objectType = (0, _ImmutableModel.getObjectType)(value);
      objectId = (0, _ImmutableModel.getId)(value);
      domain = (0, _ImmutableModel.getProperty)(value, 'domain');
      email = (0, _ImmutableModel.getProperty)(value, 'email');
      valueString = (0, _ImmutableModel.toString)(value);
      vid = value.get('vid');
      companyId = value.get('companyId');

      if (tagLinks) {
        var canViewRecord = (0, _SubjectPermissions.canView)(value);

        if (canViewRecord) {
          link = _links.default.fromObjectTypeAndId(objectType, objectId);
        }
      }
    } // todo - add some tests


    if (options && options.readOnly) {
      closeableTag = !options.readOnly;
    }

    return _react.default.createElement(_UIAvatarTag.default, {
      key: (0, _underscore.uniqueId)(objectId + " ? " + valueString),
      "data-selenium-test-bet": valueString,
      use: "calypso",
      vid: vid,
      domain: domain,
      companyId: companyId,
      email: email,
      onCloseClick: this.partial(handleRemove, value),
      closeable: closeableTag,
      onClick: onClick,
      href: link,
      target: tagLinkTarget,
      type: objectType && objectType.toLowerCase(),
      displayName: valueString
    }, _react.default.createElement("span", {
      onClick: this.handleTrackClick
    }, valueString));
  },
  render: function render() {
    var _this$props3 = this.props,
        values = _this$props3.values,
        inlineTags = _this$props3.inlineTags,
        className = _this$props3.className;

    if (!values || !values.size) {
      return null;
    }

    return _react.default.createElement(_UIList.default, (0, _extends2.default)({
      className: className,
      inline: inlineTags
    }, getSeleniumProps(this.props)), values.valueSeq().map(this.makeTag));
  }
});
var _default = AvatarTagList;
exports.default = _default;
module.exports = exports.default;